// utils/formatPrice.js
export const formatPrice = (price) => {
  if (typeof price !== 'number') price = parseFloat(price);
  if (isNaN(price)) return '0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};
